<owl-carousel-o [options]="customOptions">
  <ng-container *ngFor="let testimonial of items">
    <ng-template carouselSlide>
      <div class="testimonial-item bg-light rounded p-5">
        <div style="height: 66%;overflow-y:auto; overflow-x:hidden">
          <p class="fs-5" [innerHtml] = "testimonial.description | urlDetector"></p>
          <button  *ngIf="testimonial.videoLink" class="btn btn-primary" (click)="openArticle(testimonial)">
            {{ "view_video" | translate }}
          </button>
        </div>
        <div
          class="d-flex align-items-center bg-white me-n5 description"
          style="border-radius: 50px 0 0 50px"
        >
          <img
            class="img-fluid flex-shrink-0 rounded-circle"
            [src]="testimonial.image || 'assets/img/avatar.png'"
            style="width: 90px; height: 90px"
          />
          <div class="ps-3">
            <h3 class="mb-1" style="font-size:small;">{{ testimonial.title }}</h3>
            <span>{{ testimonial.profession }}</span>
          </div>
          <i
            class="fa fa-quote-right fa-3x text-primary ms-auto d-none d-sm-flex"
          ></i>
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
